import { useTranslation } from 'react-i18next'

import { Alert, AlertDescription } from '@/shared/components/ui/alert'
import { Header } from '@/shared/components/ui/layout'

import { useApprovalPageContext } from './ApprovalPageProvider'

export default function ApprovalPageHeader() {
	const { t } = useTranslation()

	const { isError } = useApprovalPageContext()

	return (
		<Header className='px-4 pt-2'>
			{isError && (
				<Alert variant='destructive' className='mt-2'>
					<AlertDescription>
						{t('anchoring_management.approval_page.table.error')}
					</AlertDescription>
				</Alert>
			)}
			<h3 className='text-base font-semibold'>
				{t('anchoring_management.approval_page.subtitle')}
			</h3>
		</Header>
	)
}
